const EmptyComponent = ({ message }) => {
  return (
    <div className="empty-component">
      <div className="empty-message"> {message} </div>
    </div>
  );
};

export default EmptyComponent;
